import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers'; // Update the import path if necessary

const store = configureStore({
  reducer: rootReducer,
  // Add any middleware or enhancers here if needed
});

export default store;
